export default __webpack_public_path__ + "static/326-7036f17632582abf1e2e9674a5d5932d.gif";